import React from 'react'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'

const LoadingUser = () =>
  <div className='eauth-user-fetching'>
    <h2>Loading your user, please wait.</h2>
    <LgyLoadingIcon />
  </div>

export default LoadingUser